ACC.myaccount = {
    showMyAccountPopUp: function () {
        $(".profile-box .js-profile-change-link").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $.ajax({
                url: url,
                success: function (data) {
                    $.colorbox({
                        width: false,
                        innerWidth: "570px",
                        html: $(data).find('#updateProfileForm, #updatePasswordForm'),
                        scrolling: false,
                        onLoad: function () {
                            $('#cboxClose').remove();
                        },
                        onComplete: function () {
                            $(this).colorbox.resize();
                        }
                    });
                    ACC.myaccount.validateMyAccountPopUp();
                }
            });
        })
    },
    validateMyAccountPopUp: function () {
        $('#colorbox #updateProfileForm, #colorbox #updatePasswordForm').find('.cancel_button').on("click", function (e) {
            e.preventDefault();
            $.colorbox.close();
        });
        $('#colorbox #updateProfileForm, #colorbox #updatePasswordForm').ajaxForm({
            success: function (data) {
                if ($(data).find('#updateProfileForm, #updatePasswordForm').length) {
                    $('#cboxLoadedContent').html($(data).find('#updateProfileForm, #updatePasswordForm'));
                    ACC.myaccount.validateMyAccountPopUp();
                    $.colorbox.resize();
                } else {
                    window.location.reload();
                }
            }
        });
    },

    showManagerResetPasswordPopUp: function () {
        $(".resetPasswordLink .reset-password-link").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr('data');
            $.ajax({
                url: url,
                success: function (data) {
                    $.colorbox({
                        width: false,
                        innerWidth: "570px",
                        html: $(data).find('#managerResetPasswordForm'),
                        scrolling: false,
                        onLoad: function () {
                            $('#cboxClose').remove();
                        },
                        onComplete: function () {
                            $(this).colorbox.resize();
                        }
                    });
                    ACC.myaccount.validateManagerResetPasswordPopUp();
                }
            });
        })
    },
    validateManagerResetPasswordPopUp: function () {
        $('#colorbox #managerResetPasswordForm').find('.cancel_button').on("click", function (e) {
            e.preventDefault();
            $.colorbox.close();
        });
        $('#colorbox #managerResetPasswordForm').ajaxForm({
            success: function (data) {
                if ($(data).find('#managerResetPasswordForm').length) {
                    $('#cboxLoadedContent').html($(data).find('#managerResetPasswordForm'));
                    ACC.myaccount.validateManagerResetPasswordPopUp();
                    $.colorbox.resize();
                } else {
                    window.location.reload();
                }
            }
        });
    },

    showEditCustomerPopUp: function () {
        $(".editUserLink .edit-user-link, #adduserbutton").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr('data');
            $.ajax({
                url: url,
                success: function (data) {
                    $.colorbox({
                        width: false,
                        innerWidth: "940px",
                        html: $(data).find('#editB2BCustomerForm'),
                        scrolling: false,
                        onLoad: function () {
                            $('#cboxClose').remove();
                        },
                        onComplete: function () {
                            ACC.myaccount.bindCreateUserButton();
                            $(this).colorbox.resize();
                            KMVP.tooltips.bindTooltips($('#colorbox'));
                        }
                    });
                    ACC.myaccount.validateEditCustomerPopUp();
                }
            });
        })
    },

    bindCreateUserButton: function () {
        var editCustomerForm = $(".edit-customer-form");
        if (editCustomerForm.attr("action") != "manage-users/create") {
            return;
        }
        editCustomerForm.ajaxForm({
            success: function (data) {
                if ($(data).find(".userSuccessfullyCreated").attr("data-value") === 'true') {
                    var titleVal = $(".select-UserAdministrationPopup-title").val();
                    var title = $(".select-UserAdministrationPopup-title option[value='" + titleVal + "']").text();
                    var firstname = $(".input-UserAdministrationPopup-firstName").val();
                    var lastname = $(".input-UserAdministrationPopup-surName").val();
                    ACC.myaccount.createUserConfirmation(title, firstname, lastname);
                } else {
                    ACC.myaccount.createUserFailure(data);
                }
            }
        });
    },

    createUserConfirmation: function(title, firstname, lastname) {
        var $confirmation = $(".js-edit-customer-form-confirmation");
        var html = $confirmation.html();
        html = html.replace("[0]", title);
        html = html.replace("[1]", firstname);
        html = html.replace("[2]", lastname);
        $.colorbox({
            html: html,
            innerWidth: "700px",
            onComplete: function() {
                $.colorbox.resize();
                $(".js-edit-customer-form-confirmation-close").on("click", function () {
                    $.colorbox.close();
                });
            },
            onClosed: function() {
                location.reload(true);
            }
        });
    },

    createUserFailure: function (data) {
        $.colorbox({
            innerWidth: "940px",
            html: $(data).find('#editB2BCustomerForm'),
            scrolling: false,
            onLoad: function () {
                $('#cboxClose').remove();
            },
            onComplete: function () {
                ACC.myaccount.bindCreateUserButton();
                $(this).colorbox.resize();
                KMVP.tooltips.bindTooltips($('#colorbox'));
            },
            onClosed: function () {
                location.reload(true);
            }
        });
        ACC.myaccount.validateEditCustomerPopUp();
    },

    validateEditCustomerPopUp: function () {
        $('#colorbox #editB2BCustomerForm').find('.cancel_button').on("click", function (e) {
            e.preventDefault();
            $.colorbox.close();
        });
        $('#colorbox #editB2BCustomerForm').ajaxForm({
            success: function (data) {
                if ($(data).find('#editB2BCustomerForm').length) {
                    $('#cboxLoadedContent').html($(data).find('#editB2BCustomerForm'));
                    ACC.myaccount.validateEditCustomerPopUp();
                    $.colorbox.resize();
                } else {
                    window.location.reload();
                }
            }
        });
    },
    loadAllDocuments: function () {
        var $requestDocuments = $(".js-request-documents");
        if ($requestDocuments.length <= 0) return;

        var url = $requestDocuments.data("allDocumentsUrl");

        $.ajax({
            url: url,
            success: function (data) {
                function activateLink(jsIdentifierPostfix) {
                    $(".js-doc-tooltip-" + jsIdentifierPostfix).hide();
                    $(".js-doc-link-" + jsIdentifierPostfix).show();
                }

                if (data.hasOrderConfirmation) {
                    activateLink("orderconfirmation");
                }
                if (data.hasPackageSlip) {
                    activateLink("packingslip");
                }
                if (data.hasInvoice) {
                    activateLink("invoice");
                }
                if (data.certList.length) {
                    var $jsDocCertificatesCount = $(".js-doc-certificates-count");
                    if (data.certList.length < parseInt($jsDocCertificatesCount.html())) {
                        $jsDocCertificatesCount.prepend(data.certList.length + "/")
                    }
                    activateLink("certificates");
                    data.certList.forEach(function (sapItemNo) {
                        activateLink("certificate-" + sapItemNo);
                    });
                }
                $requestDocuments.hide();
            }
        });
    },
    bindLoadingAnimationDocumentDownload: function () {
        $("a[class^='js-doc-link-']").on('click', function (e){
            e.preventDefault();
            var $this = $(this);
            var url = $this.data('url');

            $.ajax({
                type: "GET",
                url: url,
                beforeSend: function () {
                    $this.showSpinner();
                },
                success: function(/*de.ageto.hybris.kloeckner.core.order.documents.DocumentsDTO*/ data) {
                    try {
                        saveDocument(data);
                    }catch(e){
                        alert("Download failed !");
                        console.error("Error downloading file: " + e.messages);
                    }
                },
                complete: function () {
                    $this.hideSpinner();
                }, error: function(jqXHR, textStatus, errorThrown){
                    alert("Error occurred: " + (errorThrown || "Service is not reachable."));
                }
            });
        });
    }
}
function saveDocument(data){
    var blob = new Blob([base64ToArrayBuffer(data.document)], {type: "application/"+data.documentExtension});
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = data.documentFileName
    link.click();
    link.remove();
}
/***
 * Spring automatically converts bytes to base64. this function will be used on client side to decode from base64 format to bytes.
 */
function base64ToArrayBuffer(base64String) {
    var binaryString = window.atob(base64String);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

/* Extend jquery with a postJSON method */
jQuery.extend({
    postJSON: function (url, data, callback) {
        return jQuery.post(url, data, callback, "json");
    }
});

// Address Verification
$(document).ready(function () {
    ACC.myaccount.showMyAccountPopUp();
    ACC.myaccount.showManagerResetPasswordPopUp();
    ACC.myaccount.showEditCustomerPopUp();
    ACC.myaccount.bindLoadingAnimationDocumentDownload();

    if ($('.page-order').length > 0) {
        ACC.myaccount.loadAllDocuments();
    }
});
